import { useEffect } from 'react';
import { showData }  from 'utils/constants'

const useShowData = () => {

  useEffect(() => {
    if ( showData === '1' ) {
        import("functions/modal/open_modal").then(openModal => {
          openModal.handleOpenModal('data')
        });    
    }
  },[])

}

export default useShowData